<template>
  <div class="content-inner">
    <div class="charts-wrapper">
      <template v-if="STDInsuranceOEPSTD.isLoaded">
        <zingchart
          id="chart1"
          class="chart"
          :data="oepstdData"
          :height="pieChartHeight"
        />
      </template>
      <div v-else-if="true == loadFail" class="load-error">
        <p>
          Unable to load report information.
          <span v-if="!hasErrors">Please contact support.</span>
        </p>
      </div>
      <Error v-else-if="hasErrors" :errors="errors" />
      <LoadingSpinner v-else text="Loading Data" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import LoadingSpinner from "@comp/LoadingSpinner";
import Error from "@comp/ErrorDisplay";

const base = "aggRepSTDGeneral";
const group = "STDInsuranceOEPSTD";

import {
  buildTitle,
  buildSubTitle,
  buildSourceCaption,
  buildLegendTable,
  buildGUIDisplay,
  buildLabels,
  buildScale,
  buildPlot,
  PIE_CHART_HEIGHT,
} from "@/utils/charts.js";
import { newPieHash } from "@/mixins/NewChartStuff.js";

export default {
  name: "stdOffersEmployerPaidSTD",
  components: {
    LoadingSpinner,
    Error,
  },
  created() {
    if (!this[group].isLoaded) {
      this.getData(group);
    }
  },
  computed: {
    ...mapState(base, [group, "errors"]),
    ...mapGetters(base, []),
    oepstdData() {
      const pipper = newPieHash(this[group].data);
      return {
        type: "pie",
        title: buildTitle("STD Insurance - General Information"),
        subtitle: buildSubTitle(
          "Offers Employer Paid Group Short Term Disability Insurance"
        ),
        source: buildSourceCaption(),
        legend: buildLegendTable({ legendItemCount: pipper.legendItemCount }),
        gui: buildGUIDisplay(),
        labels: buildLabels(pipper.categories),
        scale: buildScale("pies"),
        plot: buildPlot(),
        series: pipper.pieData,
      };
    },
    loadFail() {
      return this[group].loadFail;
    },
    errors() {
      return this[group].errors;
    },
    hasErrors() {
      return this[group].errors?.length;
    },
    pieChartHeight() {
      return PIE_CHART_HEIGHT;
    },
  },
  methods: {
    ...mapActions(base, ["getData"]),
  },
};
</script>